// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pagelink":"Pagination__pagelink--3V5Te","altPageLink":"Pagination__altPageLink--JFlGe","active":"Pagination__active--QWdX2","disabled":"Pagination__disabled--Pzt51"};